<script>
  import { Router, Route } from 'svelte-routing';
  import TelaLogin from './Telas/TelaLogin.svelte';
  import PainelAdmin from './Telas/PainelAdmin.svelte';
  import AgendamentoPublico from './Telas/AgendamentoPublico.svelte';
  import TelaVendas from './Telas/TelaVendas.svelte';
  import TelaPagamentoPix from './Telas/TelaPagamentoPix.svelte';
  
  // NOVAS IMPORTAÇÕES
  import TelaRedefinirSenha from './Telas/TelaRedefinirSenha.svelte';
  import TelaConfirmarEmail from './Telas/TelaConfirmarEmail.svelte';
  
  import Constantes from './Classes/Constantes.js';

  export let url = '';
</script>

<Router {url}>
  <Route path={Constantes.tela_login} component={TelaLogin} />
  <Route path={Constantes.tela_painel} component={PainelAdmin} />
  
  <Route path="/redefinir" component={TelaRedefinirSenha} />
  <Route path="/confirmar" component={TelaConfirmarEmail} />
  <Route path="/pix" component={TelaPagamentoPix} />

  <Route path={Constantes.tela_agendamento} let:params>
    <AgendamentoPublico slug={params.slug} />
  </Route>
  <Route path="/" component={TelaVendas} />
</Router>